
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.75 38.5h-5.5M21.136 3.397C17.87 6.012 6.953 16.46 16.5 33h11c9.348-16.528-1.41-26.974-4.64-29.598a1.372 1.372 0 00-1.724-.005v0z","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.696 19.14l-5.389 6.466a1.375 1.375 0 00-.285 1.178l2.124 9.562a1.375 1.375 0 002.202.776L16.5 33M31.2 19.016l5.493 6.59a1.375 1.375 0 01.285 1.178l-2.124 9.562a1.375 1.375 0 01-2.202.776L27.5 33","stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M22 18.563a2.062 2.062 0 100-4.125 2.062 2.062 0 000 4.124z","fill":"#56BFC7"}})])
          )
        }
      }
    